.mos-ars-body-tree-view {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 1rem;
  background: #f5f5f5;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.875rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.mos-ars-body-tree-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.mos-ars-body-tree-heading {
  margin: 0;
  padding: 0.5rem 0;
  font-size: 1rem;
  font-weight: 600;
  border-bottom: 2px solid #333;
  color: #333;
}

.mos-ars-body-tree-content {
  background: white;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 0.75rem;
  max-height: 600px;
  overflow-y: auto;
}

.mos-ars-body-tree-empty {
  margin: 0;
  padding: 0.5rem;
  color: #999;
  font-style: italic;
  font-family: sans-serif;
}

.mos-ars-tree-node {
  margin-bottom: 0.25rem;
}

.mos-ars-tree-node-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 2px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f0f0f0;
  }
}

.mos-ars-tree-node-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.2rem;
  height: 1.2rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.75rem;
  color: #666;
  transition: color 0.15s ease;

  &:hover {
    color: #333;
  }
}

.mos-ars-tree-node-spacer {
  display: inline-block;
  width: 1.2rem;
}

.mos-ars-tree-node-type {
  display: inline-block;
  min-width: 6rem;
  padding: 0.125rem 0.5rem;
  border-radius: 3px;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &.mos-ars-tree-node-type-analysisMethod {
    background-color: #e3f2fd;
    color: #156534;
  }

  &.mos-ars-tree-node-type-operation {
    background-color: #e3f2fd;
    color: #1565c0;
  }

  &.mos-ars-tree-node-type-subgroup {
    background-color: #f3e5f5;
    color: #6a1b9a;
  }

  &.mos-ars-tree-node-type-groupingFactor {
    background-color: #e8f5e9;
    color: #2e7d32;
  }

  &.mos-ars-tree-node-type-group {
    background-color: #fff3e0;
    color: #e65100;
  }
}

.mos-ars-tree-node-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  color: #333;
}

.mos-ars-tree-node-id {
  display: inline-block;
  max-width: 12rem;
  padding: 0 0.5rem;
  color: #999;
  font-size: 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-left: 1px solid #e0e0e0;
}

.mos-ars-tree-node-children {
  margin-left: 1.5rem;
  margin-top: 0.25rem;
  padding-left: 0.75rem;
  border-left: 2px solid #e0e0e0;
}
